import useRoutes from 'lib/hooks/useRoutes'
import React from 'react'
import { HOME_PATH } from 'routes/constants.routes'

import delorian from './Delorean.webp'
import './style.css'

const NoMatch = () => {
  const { push } = useRoutes()

  return (
    <div className="notFoundContainer">
      <section className="notFound">
        <div className="img">
          <img src={delorian} alt="El Delorean, El Doc y Marti McFly" />
        </div>
        <div className="text">
          <h1>404</h1>
          <h2>Страница не найдена!</h2>
          <h3>Вернуться домой?</h3>
          <a onClick={() => push(HOME_PATH)} className="yes">
            ДА
          </a>
        </div>
      </section>
    </div>
  )
}
export default NoMatch
